import {SgfDetMovDia} from './../../_model/';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {config} from 'environments/config';
import {AuthenticationService} from 'app/auth/service';
import {AlertService} from '../alert/alert.service';
import {User} from 'app/auth/models';

@Injectable({
    providedIn: 'root'
})
export class Sgf_det_mov_diaService {
    public currentUser: User;

    constructor(private http: HttpClient,
                private _authenticationService: AuthenticationService,
                private alertService: AlertService) {
        this._authenticationService.currentUser.subscribe(x => (this.currentUser = x));
    }

    getComprobantes(token: string, oficina, transaccion, numtransaccion) {
        const params = {
            "id": null,
            "corte": null,
            "token": [token],
            "status": 0,
            "message": "",
            "data": [
                {
                    "id": {
                        "codOficina": oficina,
                        "codTransaccion": transaccion,
                        "numTransaccion": numtransaccion,
                        "numSec": 1
                    }
                }
            ]
        };
        return this.http.post<any>(`${config.apiUrl}/detmovdia/comprobantes`, params)
            .toPromise()
            .then(res => <SgfDetMovDia>res.obj)
            .then(data => {
                return data;
            });// .catch(error => this.alertService.error('Se ha producido un error Intente de nuevo'));
            /*.toPromise()
            .then(res => <SgfDetMovDia>res.obj)
            .then(data => {
                return data;
            }).catch(error => this.alertService.error('Se ha producido un error Intente de nuevo'));*/
    }
}
